import { jsx as _jsx } from "react/jsx-runtime";
import { useClassified } from "@/contexts/classified";
import { useSellerLeadLink } from "../Sections/SellerLeadTeaser";
import { SimilarListings } from "../SimilarListings/SimilarListings";
export const SimilarProviderListings = () => {
    var _a, _b, _c;
    const providerListings = (_c = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.providerListings) === null || _b === void 0 ? void 0 : _b.filter((card) => card.status === "Published")) !== null && _c !== void 0 ? _c : null;
    const providerRecords = (providerListings !== null && providerListings !== void 0 ? providerListings : [])
        .filter((card) => Object.keys(card).length > 1)
        .reduce((acc, card) => (Object.assign(Object.assign({}, acc), { [card.id]: card })), {});
    const isDisplayed = !!(providerListings === null || providerListings === void 0 ? void 0 : providerListings.length);
    const { funnel: funnelUrl } = useSellerLeadLink();
    return (_jsx(SimilarListings, { similarListings: providerListings, similarRecords: providerRecords, isDisplayed: isDisplayed, funnelUrl: funnelUrl || null, isSimilarProviderListings: true, isErrorPageDisplay: true }));
};
